import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { TrainingProgram } from '@models/training/training-program.model';
import { TrainingProgramRecord } from '@models/training/training-program-record.model';
import { ActivatedRoute } from '@angular/router';
import { Employee } from '@models/employee/employee.model';
import { RecordForm } from '@forms/training/components';
import { AuthService, NotifyService } from '@app/services';
import { BaseForm } from '@forms/base.form';

@Component({
    selector: 'app-training-once-off-form',
    templateUrl: './once-off-training.template.html',
    styleUrls: ['./once-off-training.style.scss'],
})
export class OnceOffTrainingForm extends BaseForm implements OnInit {
    @ViewChild('trainingRecordForm') trainingRecordForm: RecordForm;
    @Output() closeDialogue: EventEmitter<any> = new EventEmitter<any>();
    @Output() saved: EventEmitter<any> = new EventEmitter<any>();

    employee: Employee;
    headerText = 'Create Complete Training';
    program: TrainingProgram | null = null;
    record: TrainingProgramRecord | null = null;
    programName: string | null = null;
    programs: TrainingProgram[] = [];
    isExistingProgram = true;

    constructor(
        private changeDetection: ChangeDetectorRef,
        private route: ActivatedRoute,
        private notify: NotifyService,
        protected auth: AuthService
    ) {
        super();
    }

    ngOnInit(): void {
        this.employee = this.route.snapshot.data.models.get('employee');
        if (this.auth.can(TrainingProgram.managePermission)) {
            TrainingProgram.query()
                .all()
                .then(([programs]) => {
                    this.programs = programs;
                });
        }
    }

    programChange(): void {
        if (this.program) {
            this.record = TrainingProgramRecord.createOnceOff(this.program);
        } else {
            this.record = null;
        }
        // need two change detection events else the form may not be defined
        this.changeDetection.detectChanges();
        this.trainingRecordForm.record = this.record;
        this.changeDetection.detectChanges();
    }

    isExistingProgramChange(): void {
        if (!this.isExistingProgram) {
            this.program = TrainingProgram.createOnceOff();
            this.record = TrainingProgramRecord.createOnceOff(this.program);
        } else {
            this.record = null;
        }
        // need two change detection events else the form may not be defined correctly
        this.changeDetection.detectChanges();
        if (this.trainingRecordForm) {
            this.trainingRecordForm.record = this.record;
        }
        this.changeDetection.detectChanges();
    }

    saveRecord(): void {
        if (!this.program) {
            this.notify.error('forms.training.selectOrCreateTrainingProgram');
            return;
        }

        if (!this.program.id) {
            this.program.name = this.programName;
            this.program
                .create()
                .then((program: TrainingProgram) => {
                    this.record.attach('trainingPrograms', [program.id]);
                    this.record.attach('employees', [this.employee.id]);
                    this.trainingRecordForm.saveRecord();
                })
                .catch((err) => {
                    this.notify.error(err.message || 'forms.training.savingTrainingProgramFailed');
                });
        } else {
            this.record.attach('trainingPrograms', [this.program.id]);
            this.record.attach('employees', [this.employee.id]);
            this.trainingRecordForm.saveRecord();
        }
    }

    onSaveRecord(): void {
        this.program = null;
        this.record = null;
        this.saved.emit();
    }

    close(): void {
        this.program = null;
        this.record = null;
        this.closeDialogue.emit();
    }
}
